import { apiFetch } from './apiFetch';

const API_BASE = import.meta.env.VITE_API_URL || '';
const SESSION_KEY = 'ic_session_id';
const DEBOUNCE_MS = 2000;

let lastPath = '';
let lastTime = 0;

function getSessionId(): string {
  let id = localStorage.getItem(SESSION_KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(SESSION_KEY, id);
  }
  return id;
}

export function trackPageView(path: string): void {
  // Don't track if Do Not Track is enabled
  if (navigator.doNotTrack === '1') return;

  // Don't track admin pages
  if (path.startsWith('/admin')) return;

  // Debounce: don't track same page within 2s
  const now = Date.now();
  if (path === lastPath && now - lastTime < DEBOUNCE_MS) return;
  lastPath = path;
  lastTime = now;

  const sessionId = getSessionId();

  apiFetch(`${API_BASE}/api/analytics/page-view`, {
    method: 'POST',
    body: JSON.stringify({
      path,
      referrer: document.referrer || null,
      sessionId,
    }),
    // Fire-and-forget: use keepalive so the request survives page unload
    keepalive: true,
  }).catch(() => {
    // Silently ignore errors — analytics should never break the site
  });
}
